import * as React from "react";
import { 
  OtpValidatePhone, 
  // ResendOtpController 
} from "@njoy/controller";
import { validateOTPSchema } from "@njoy/common";
import { Field, Form, Formik } from "formik";
import { Form as AntForm } from "antd";
import { SuccessModal } from "../../../../../components/modals/sucessModal"
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton"
import { InputOTPField } from "../../../../shared/InputOTPField"
import { useState } from "react";
import * as ROUTES from "../../../../../constants/routes";
import ToastMessage from "../../../../../hooks/useToast";
import { extractError } from "../../../../../utils/extractError";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Mock controller for UI testing
// const mockOtpPhoneValidate = async ({ variables }: { variables: { verificationCode: string; phone: string } }) => {
//   console.log("Mock OTP phone validate called with:", variables);
//   // Simulate API response
//   if (variables.verificationCode === "1234") {
//     return {
//       data: {
//         otpPhoneValidate: {
//           message: "Phone number verified successfully!",
//           errors: null
//         }
//       }
//     };
//   } else {
//     return {
//       data: {
//         otpPhoneValidate: {
//           message: null,
//           errors: [{ path: "verificationCode", message: "Invalid OTP code" }]
//         }
//       }
//     };
//   }
// };

const FormItem = AntForm.Item;

export interface OTPValidateFormValues {
  verificationCode: string;
}

function normalizeErrors(errors: { path: string; message: string }[]): Record<string, string> {
  const errMap: Record<string, string> = {};
  errors.forEach(e => {
    if (e && e.path) {
      errMap[e.path] = e.message;
    }
  });
  return errMap;
}

export const ChangePhoneNumberOtpPage: React.FC = () => {
  const [phone, setPhone] = useState<string>("");
  // const [email, setEmail] = useState<string>("");
  const [visible, setVisible] = useState(false);

  const onFinish = () => {
    window.location.replace(ROUTES.ACCOUNT_DETAILS);
  };

  const formatPhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return "";
    
    // Remove any existing formatting
    const cleanPhone = phoneNumber.replace(/\D/g, "");
    
    // Check if it starts with 234 (Nigeria country code)
    if (cleanPhone.startsWith("234") && cleanPhone.length >= 13) {
      const countryCode = "+234";
      const remaining = cleanPhone.substring(3);
      const first3 = remaining.substring(0, 3);
      const second3 = remaining.substring(3, 6);
      const last4 = remaining.substring(6, 10);
      
      return `${countryCode}-${first3}-${second3}-${last4}`;
    }
    
    // Return original if doesn't match expected format
    return phoneNumber;
  };

  React.useEffect(() => {
    const foundPhone = localStorage.getItem('phone');
    // const foundEmail = localStorage.getItem('email');
    setPhone(foundPhone || "");
    // setEmail(foundEmail || "");
  }, []);

  return (
    <OtpValidatePhone>
      {({ otpValidatePhone }) => (
        <Formik<OTPValidateFormValues>
          validationSchema={validateOTPSchema}
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            verificationCode: ""
          }}
          onSubmit={async (
            { verificationCode },
            { resetForm, setSubmitting, setErrors, setValues }
          ) => {
            
            // Simulate API response
           const response = await otpValidatePhone({ variables: {verificationCode, phone}  });
            setSubmitting(false);
            resetForm();
            verificationCode = "";
            setValues({ verificationCode: ""});

            if (!response || !response.data) {
              setErrors({ verificationCode: "No response from server. Please try again." });
              ToastMessage("error", "No response from server. Please try again.");
              return;
            }
           

            const result = response.data.otpValidatePhone;
            // console.log(result)
            if (result?.errors && result.errors.length > 0) {
              const errorMap = normalizeErrors(result.errors);
              setErrors(errorMap);
              ToastMessage("error", extractError(errorMap));
              return;
            }

            // const result = response.data.o;

            if (result?.message) {
              ToastMessage("success", result.message);
              localStorage.removeItem("phone");
              localStorage.removeItem("email");
              setVisible(true);
            }
          }}>
          {({ isSubmitting }) => (
            <TemplateSub page={"Enter OTP"}>
              <ToastContainer />
              <div className="mt-8 mb-2 w-full flex-1 flex flex-col">
                <p className="px-[3rem] text-[16px] py-10 text-center text-white">
                  We sent an OTP to <span className="font-bold">{formatPhoneNumber(phone)}</span>.
                  Enter it below to continue.
                </p>

                <Form className="flex flex-col px-[1rem] flex-1">
                  <Field
                    name="verificationCode"
                    component={InputOTPField}
                    otpLength={4}
                  />

                  <div className="mt-auto ">
                    <FormItem>
                      <NewButton
                        loading={isSubmitting}
                        fullWidth
                        variant="primary"
                        type="submit"
                      >
                        Done
                      </NewButton>
                    </FormItem>
                  </div>
                </Form>
                <SuccessModal
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  caption="Your phone number has been changed successfully."
                  onClick={() => {
                    setVisible(false);

                    onFinish();
                  }}
                />
              </div>
            </TemplateSub>
          )}
        </Formik>
    )}
    </OtpValidatePhone>
  );
};